/* esm.sh - rxjs@7.8.1/dist/esm/internal/util/pipe */
import{identity as n}from"./identity.mjs";function c(...r){return p(r)}function p(r){return r.length===0?n:r.length===1?r[0]:function(e){return r.reduce((t,i)=>i(t),e)}}export{c as pipe,p as pipeFromArray};
//# sourceMappingURL=pipe.mjs.map